import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const importantDataForm: Form<Client> = {
  key: 'importantData',
  fields: [
    {
      key: 'targetGroup',
      label: 'Zielgruppe',
      xsWidth: 12,
      fieldTypes: 'checkboxSelect',
      options: [
        {
          value: 'female',
          label: 'Frau',
        },
        {
          value: 'child',
          label: 'Kind',
        },
        {
          value: 'juvenile',
          label: 'Jugendliche/r',
        },
        {
          value: 'helperGroup',
          label: 'Helferkreis',
        },
        {
          value: 'specialist',
          label: 'Fachkraft',
        },
        {
          value: 'formerWomensShelter',
          label: 'ehemals Frauenhaus',
        },
        {
          value: 'formerIST',
          label: 'ehemals IST',
        },
      ],
    },
    {
      key: 'personExercisingViolence',
      label: 'Gewalt ausübende Person',
      xsWidth: 12,
      fieldTypes: 'checkboxSelect',
      options: [
        { label: 'Gewalt durch Ehe/-Lebenspartner', value: 'violenceByPartner' },
        { label: 'Gewalt durch Ex-Lebenspartner', value: 'violenceByExPartner' },
        { label: 'Familie/soziales Nahfeld', value: 'familyOrSocialEnvironment' },
        { label: 'Sonstige', value: 'other' },
      ],
    },
    {
      key: 'otherPersonExercisingViolence',
      label: 'Sonstige Gewalt ausübende Person',
      fieldTypes: 'text',
      isVisible: (client) =>
        client.personExercisingViolence != null && client.personExercisingViolence.includes('other'),
    },
    {
      key: 'namedViolence',
      label: 'Benannte Gewalt',
      xsWidth: 12,
      fieldTypes: 'checkboxSelect',
      options: [
        { label: 'psychisch', value: 'mental' },
        { label: 'körperlich', value: 'physical' },
        { label: 'sexuell', value: 'sexual' },
        { label: 'Stalking', value: 'stalking' },
        { label: 'Fremdstalking', value: 'stalkingByStrangers' },
        { label: 'Sonstige', value: 'other' },
      ],
    },
    {
      key: 'otherNamedViolence',
      label: 'Sonstige benannte Gewalt',
      fieldTypes: 'text',
      isVisible: (client) => client.namedViolence != null && client.namedViolence.includes('other'),
    },
    {
      key: 'contact',
      label: 'Kontaktaufnahme zu',
      xsWidth: 12,
      fieldTypes: 'checkboxSelect',
      options: [
        { label: 'Justiz', value: 'justice' },
        { label: 'Anwältin', value: 'laywer' },
        { label: 'Polizei', value: 'police' },
        { label: 'Jugendamt', value: 'youthWelfareOffice' },
        { label: 'Erziehungsberatungsstelle', value: 'educationalCounselingCenter' },
        { label: 'Migrationsberatung', value: 'MigrationCounseling' },
        { label: 'Sozialpsychiatrischer Dienst', value: 'socialPsychiatricService' },
        { label: 'Weißer Ring', value: 'weißerRing' },
        { label: 'Familienberatungsstelle', value: 'familyCounselingCenter' },
        { label: 'Therapeutin', value: 'therapist' },
        { label: 'Sonstige', value: 'other' },
      ],
    },
    {
      key: 'otherContact',
      label: 'Sonstige Kontaktaufnahme',
      fieldTypes: 'text',
      isVisible: (client) => client.contact != null && client.contact.includes('other'),
    },
  ],
};

export default importantDataForm;
